import React from "react";
import { classNames } from "primereact/utils";
import { DashlyFieldLabel } from "./DashlyFieldLabelInfo";
import "./dashlyFormControl.scss";

export type DashlyFieldShellProps = {
    label?: React.ReactNode;
    labelInfo?: string;
    hint?: React.ReactNode;
    error?: React.ReactNode;
    htmlFor?: string;
    required?: boolean;
    className?: string;
    labelClassName?: string;
    children: React.ReactNode;
};

export const DashlyFieldShell: React.FC<DashlyFieldShellProps> = ({
    label,
    labelInfo,
    hint,
    error,
    htmlFor,
    required,
    className,
    labelClassName,
    children,
}) => (
    <div className={classNames("dashly-field-shell", error && "dashly-field-shell--invalid", className)}>
        {label ? (
            <label className={classNames("dashly-field-shell__label", labelClassName)} htmlFor={htmlFor}>
                <DashlyFieldLabel label={label} labelInfo={labelInfo} required={required} />
            </label>
        ) : null}
        {children}
        {error ? (
            <span className="dashly-field-shell__error" role="alert">
                {error}
            </span>
        ) : hint ? (
            <span className="dashly-field-shell__hint">{hint}</span>
        ) : null}
    </div>
);
